import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllClients } from "../../Redux/WhatsappSlice/Client";
import { fetchSlabDetailList } from "../../Redux/WhatsappSlice/Slab";
import { toast } from "react-toastify";
import {
  AddWpClientDetail,
  DeleteWpClientDetail,
  fetchAllWpClientDetails,
  UpdateWpClientDetail,
} from "../../Redux/WhatsappSlice/WhatsAppRegistration";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import Loader from "../../Components/Loader/Loader";

const WhatsAppClientDetail = () => {
  const formatDate = (date) => {
    if (!date) return "";
    const selectedDate = new Date(date); // This will be YYYY-MM-DD format

    const now = new Date(); // Current time

    // Apply hours and minutes from now to selected date
    selectedDate.setHours(now.getHours());
    selectedDate.setMinutes(now.getMinutes());

    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    const day = String(selectedDate.getDate()).padStart(2, "0");
    const hours = String(selectedDate.getHours()).padStart(2, "0");
    const minutes = String(selectedDate.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = String(d.getFullYear()).slice(-2); // Get last 2 digits of year
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const dispatch = useDispatch();

  const { AllClients } = useSelector((state) => state.Client);
  const { SlabDetailList } = useSelector((state) => state.Slab);
  const { WpClientDetailsData } = useSelector((state) => state.WpRegistration);

  const [formData, setFormData] = useState({
    WhaClientName: "",
    WhaSlabDtID: "",
    WhaSlabName: "",
    WhaCount: 0,
    WhaBalCount: 0,
    WhaDate: "",
  });

  const [editId, setEditId] = useState(null);
  // const [searchText, setSearchText] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchAllClients());
    dispatch(fetchSlabDetailList());
    dispatch(fetchAllWpClientDetails());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSlabNameChange = (e) => {
    const selectedSlabID = e.target.value;

    const selectedSlab = SlabDetailList.find(
      (item) => item.WhaSlabID?._id === selectedSlabID
    );

    setFormData((prev) => ({
      ...prev,
      WhaSlabDtID: selectedSlabID,
      WhaSlabName: selectedSlab?.WhaSlabID?.WhaSlabName || "",
    }));

    setErrors((prev) => ({ ...prev, WhaSlabDtID: "" }));
  };

  const validate = (formData) => {
    const errors = {};

    if (!formData.WhaClientName || formData.WhaClientName.length === 0) {
      errors.WhaClientName = "Client name is required";
    }

    if (!formData.WhaSlabDtID || formData.WhaSlabDtID.length === 0) {
      errors.WhaSlabDtID = "Slab Name is required";
    }

    // Fix for WhaCount validation (number instead of string)
    if (
      formData.WhaCount === null ||
      formData.WhaCount === undefined ||
      formData.WhaCount === ""
    ) {
      errors.WhaCount = "Total Balance is required";
    } else if (isNaN(formData.WhaCount)) {
      errors.WhaCount = "Total Balance must be a number";
    }

    // Fix for WhaBalCount validation (number instead of string)
    if (
      formData.WhaBalCount === null ||
      formData.WhaBalCount === undefined ||
      formData.WhaBalCount === ""
    ) {
      errors.WhaBalCount = "Balance is required";
    } else if (isNaN(formData.WhaBalCount)) {
      errors.WhaBalCount = "Balance must be a number";
    }

    if (!formData.WhaDate || formData.WhaDate.trim() === "") {
      errors.WhaDate = "Date is required";
    }

    return errors;
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this item?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteWpClientDetail({ id: row.MainId })).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchAllWpClientDetails()); // refresh list
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  // const handleEdit = (row) => {
  //   setEditId(row.MainId);


  //   const formattedDate = formatDate(row.WhaDate);
  //   setFormData({
  //     WhaClientName: row?.WhaClientID?._id || "",
  //     WhaSlabDtID: row?.WhaSlabDtID?._id || "",
  //     WhaSlabName: row?.WhaSlabDtID?.WhaSlabID?.WhaSlabName || "",
  //     WhaCount: row.WhaCount,
  //     WhaBalCount: row.WhaBalCount,
  //     WhaDate: formattedDate,
  //   });
  // };

  // const handleEdit = (row) => {
  //   setEditId(row.MainId);

  //   // Find the client ID that matches the client name in the row
  //   const client = AllClients?.data?.find(
  //     (c) => c.WhaClientName === row.WhaClientName
  //   );
  //   const clientId = client?._id || "";

  //   // Find the slab ID that matches the slab name in the row
  //   const slab = SlabDetailList?.find(
  //     (s) => s.WhaSlabID?.WhaSlabName === row.WhaSlabName
  //   );
  //   const slabId = slab?._id || "";

  //   setFormData({
  //     WhaClientName: clientId,
  //     WhaSlabDtID: slabId,
  //     WhaSlabName: row.WhaSlabName,
  //     WhaCount: row.WhaCount,
  //     WhaBalCount: row.WhaBalCount,
  //     WhaDate: row?.WhaDate
  //       ? new Date(row?.WhaDate).toISOString().split("T")[0]
  //       : "",
  //   });
  // };

  const handleEdit = (row) => {
    setEditId(row.MainId);

    // 1. Find the original data object from the Redux state
    //    using the unique ID (MainId) from the table row.
    const originalRowData = WpClientDetailsData.find(
      (item) => item._id === row.MainId
    );

    // 2. Add a check to ensure the data was found.
    if (!originalRowData) {
      return;
    }

    // 3. Use the original, unformatted WhaDate from the found object.
    const originalDate = originalRowData.WhaDate;

    setFormData({
      WhaClientName: originalRowData?.WhaClientID?._id || "",
      WhaSlabDtID: originalRowData?.WhaSlabDtID?._id || "",
      WhaSlabName: originalRowData?.WhaSlabDtID?.WhaSlabID?.WhaSlabName || "",
      WhaCount: originalRowData.WhaCount,
      WhaBalCount: originalRowData.WhaBalCount,
      // This is the corrected line. It now uses the originalDate.
      WhaDate: originalDate
        ? new Date(originalDate).toISOString().split("T")[0]
        : "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const formattedData = {
        ...formData,
        WhaCount: Number(formData.WhaCount),
        WhaBalCount: Number(formData.WhaBalCount),
        WhaDate: formatDate(formData.WhaDate),
      };

      try {
        if (editId) {
          await dispatch(
            UpdateWpClientDetail({ id: editId, updatedClient: formattedData })
          ).unwrap();
          toast.success("WP Client Detail updated successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        } else {
          await dispatch(AddWpClientDetail({ values: formattedData })).unwrap();
          toast.success("WP Client Detail Added Successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        }

        // Reset form
        setFormData({
          WhaClientName: "",
          WhaSlabDtID: "",
          WhaSlabName: "",
          WhaCount: 0,
          WhaBalCount: 0,
          WhaDate: "",
        });
        dispatch(fetchAllWpClientDetails());
      } catch (error) {
        toast.error(
          `Failed to add WhatsApp Client Detail: ${error.message || "Unknown error"
          }`,
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
          }
        );
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    { field: "WhaClientName", headerName: "Client Name", flex: 1 },
    { field: "WhaSlabName", headerName: "Slab Name", flex: 1 },
    { field: "WhaCount", headerName: "Total Balance", flex: 1 },
    { field: "WhaBalCount", headerName: "Balance", flex: 1 },
    { field: "WhaDate", headerName: "Date-Time", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          {/* <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button> */}
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rows = (WpClientDetailsData || [])?.map((el, index) => ({
    id: index + 1,
    MainId: el._id,
    WhaClientName: el?.WhaClientID?.WhaClientName,
    WhaSlabName: el?.WhaSlabDtID?.WhaSlabID?.WhaSlabName,
    WhaCount: el?.WhaCount,
    WhaBalCount: el?.WhaBalCount,
    WhaDate: formatDisplayDate(el?.WhaDate),
  }));

  if (
    !AllClients?.data ||
    !SlabDetailList ||
    !WpClientDetailsData
  ) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            {/* WhatsApp Client Detail */}
            {editId ? "Update Wp Client Detail" : "Add WhatsApp Client Detail"}
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            {/* Client Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Client Name</h5>
              <select
                name="WhaClientName"
                value={formData.WhaClientName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Client</option>
                {[...(AllClients?.data || [])]
                  .sort((a, b) => (a.WhaClientName || "").localeCompare(b.WhaClientName || ""))
                  .map((client) => (
                    <option key={client?._id} value={client?._id}>
                      {client.WhaClientName}
                    </option>
                  ))}
              </select>
              {errors.WhaClientName && (
                <p className="text-red-500 text-sm">{errors.WhaClientName}</p>
              )}
            </div>

            {/* Slab Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Slab Name</h5>
              <select
                name="WhaSlabDtID"
                value={formData.WhaSlabDtID}
                onChange={handleSlabNameChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Slab Name</option>
                {[...(SlabDetailList || [])]
                  .sort((a, b) => (a.WhaSlabID?.WhaSlabName || "").localeCompare(b.WhaSlabID?.WhaSlabName || ""))
                  .map((option) => (
                    <option key={option._id} value={option?._id}>
                      {option.WhaSlabID?.WhaSlabName}
                    </option>
                  ))}
              </select>
              {errors.WhaSlabDtID && (
                <p className="text-red-500 text-sm">{errors.WhaSlabDtID}</p>
              )}
            </div>

            {/* Total Count Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Total Count</h5>
              <input
                type="number"
                name="WhaCount"
                // placeholder="Enter Static IP Number"
                value={formData.WhaCount}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.WhaCount && (
                <p className="text-red-500 text-sm">{errors.WhaCount}</p>
              )}
            </div>

            {/* Balance Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Balance</h5>
              <input
                type="number"
                name="WhaBalCount"
                value={formData.WhaBalCount}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.WhaBalCount && (
                <p className="text-red-500 text-sm">{errors.WhaBalCount}</p>
              )}
            </div>

            {/* Date Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="b-1 block font-semibold">Date</h5>
              <input
                type="date"
                name="WhaDate"
                placeholder="Enter version number"
                value={formData?.WhaDate?.split(" ")[0]}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.WhaDate && (
                <p className="text-red-500 text-sm">{errors.WhaDate}</p>
              )}
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                {editId ? "Update" : "Submit"}
              </button>

              {editId && (
                <button
                  type="button"
                  className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                  onClick={() => {
                    setFormData({
                      WhaClientName: "",
                      WhaSlabDtID: "",
                      WhaSlabName: "",
                      WhaCount: 0,
                      WhaBalCount: 0,
                      WhaDate: "",
                    });
                    setEditId(null);
                    setErrors({});
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        <div className="px-2 py-6">
          <div className="title">
            <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block text-uppercase rounded">
              View WhatsApp Client Detail
            </h3>
          </div>
          <div className="rounded-lg overflow-x-auto mt-3">
            <WpDynamicTable columns={columns} rows={rows} />
          </div>
        </div>
      </div>
    </>
  );
};

export default WhatsAppClientDetail;
